export default {
  props: {
    navigation: {
      type: Array,
      required: true,
    },
  },
}
